// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"fac1901b","687":"321871e4"}[chunkId] + ".chunk.js";
};